<div class="upload-content">
    <!-- Header Section -->
    <div class="modal-header">
        <div class="header-left">
            <div class="breadcrumb" *ngIf="path">
                <span class="lato-16-b-vw text-color path-text"
                    [ngClass]="{'ellipsis' : path.length > 100}" [innerHTML]="path"
                    placement="bottom"
                    [ngbTooltip]="pathForToolTip + (controlName ? ' | ' + controlName : '')">
                </span>
                <span class="lato-16-b-vw text-color separator"
                    *ngIf="controlName">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                <span class="txt-white lato-16-b-vw control-name" *ngIf="controlName">{{ controlName
                    }}</span>
            </div>
            <div class="question-text-wrapper" *ngIf="questionText">
                <div #questionTextElement class="question-text lato-16-n-vw"
                    [class.collapsed]="!showQuestionExt"
                    [class.large-question]="showQuestionExt">
                    <span *ngIf="questionNumber">{{ questionNumber }}.&nbsp;</span>{{ questionText }}
                    <div *ngIf="showQuestionExt" class="close-link lato-16-n-vw"
                        (click)="showQuestionExt = false">Close</div>
                </div>
                <span *ngIf="isTextOverflowing && !showQuestionExt" class="more-link lato-16-n-vw"
                    (click)="showQuestionExt = true">...more</span>
            </div>
        </div>
        <div class="header-close-big">
            <div class="close-cross-icon" (click)="closeModal()" cygovSvgIcon
                [svgName]="'x-icon-type2'">
            </div>
        </div>
    </div>

    <!-- Main Content - Two Columns -->
    <div class="modal-content-wrapper" *ngIf="this.startUpload">
        <!-- Left Column - Link from Artifacts List -->
        <div class="left-column">
            <div class="column-header">
                <span class="lato-16-n-vw">LINK FROM ARTIFACTS REGISTRY</span>
            </div>
            <div class="search-sort-container">
                <div class="search-container">
                    <div class="search-icon" cygovSvgIcon [svgName]="'search-icon'"></div>
                    <input type="text" class="search-input" placeholder="Search"
                        [(ngModel)]="artifactSearchText" (ngModelChange)="onArtifactSearch()" />
                </div>
                <div class="sort-dropdown-container" (click)="$event.stopPropagation()">
                    <div class="sort-dropdown lato-14-n-vw"
                        [ngClass]="{ 'dropdown-open': isDropdownOpen }"
                        (click)="onDropdownClick($event)">
                        <span class="sort-display-text lato-14-n-vw"
                            [ngClass]="{ 'dropdown-open': isDropdownOpen }">{{ getSortDisplayText()
                            }}</span>
                        <span class="category-arrow" [ngClass]="{ 'arrow-open': isDropdownOpen }"
                            cygovSvgIcon [svgName]="'arrow-right-type3'"></span>
                    </div>
                    <div class="custom-dropdown-options" [class.dropdown-visible]="isDropdownOpen"
                        *ngIf="isDropdownOpen">
                        <div class="dropdown-option" *ngIf="sortOrder === 'latest'"
                            (click)="onOptionSelect('oldest')"
                            (mousedown)="$event.preventDefault()">
                            Oldest
                        </div>
                        <div class="dropdown-option" *ngIf="sortOrder === 'oldest'"
                            (click)="onOptionSelect('latest')"
                            (mousedown)="$event.preventDefault()">
                            Newest
                        </div>
                    </div>
                </div>
            </div>
            <div class="artifacts-list-container">
                <div *ngIf="isLoadingArtifacts" class="artifacts-list skeleton-list" aria-hidden="true">
                    <div class="artifact-item" *ngFor="let row of skeletonRows">
                        <cygov-skeleton width="16px" height="16px" radius="3px"></cygov-skeleton>
                        <div class="artifact-details">
                            <cygov-skeleton width="10vw" height="1.3vh"></cygov-skeleton>
                            <cygov-skeleton width="14vw" height="1.1vh"></cygov-skeleton>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isLoadingArtifacts && filteredArtifacts.length === 0"
                    class="empty-state">
                    No artifacts found
                </div>
                <div class="artifacts-list"
                    *ngIf="!isLoadingArtifacts && filteredArtifacts.length > 0">
                    <div class="artifact-item" *ngFor="let artifact of filteredArtifacts"
                        (click)="toggleArtifactSelection(artifact.id)">
                        <cygov-checkbox [id]="'artifact-' + artifact.id"
                            [isChecked]="isArtifactSelected(artifact.id)"
                            (changed)="onArtifactCheckboxChange(artifact.id, $event)" [width]="16"
                            [height]="16"></cygov-checkbox>
                        <div class="artifact-details">
                            <div class="artifact-name lato-16-n-vw">{{ artifact.name }}</div>
                            <div class="artifact-meta">
                                <span class="created-by-label lato-16-n-vw">Created By:</span>
                                <span class="created-by-value lato-16-n-vw">{{ artifact.uploadedBy
                                    }} | </span>
                                <span class="created-date lato-16-n-vw">{{ artifact.uploadedDate
                                    }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Right Column - File Upload -->
        <div class="right-column">
            <div class="positioning-center" ng2FileDrop [uploader]="uploader"
                (onFileDrop)="handleFileInput($event)" (click)="onDragAreaClick()">
                <div class="body">
                    <img class="upload-cloud-img" src="assets/images/upload-cloud-no-background.png"
                        draggable="false" alt="Cloud Upload" />
                    <div id="caller" class="center-align-text">
                        Drag files here or
                        <span class="browse-text">browse</span>
                        <input #fileInput class="hide-input-file" type="file" ng2FileSelect
                            [uploader]="uploader"
                            accept=".gif, .jpeg, .jpg, .png, .doc, .docx, .csv, .pdf, .xls, .xlsx, .ppt, .txt"
                            (onFileSelected)="handleFileInput($event)" multiple />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer Section -->
    <div class="modal-footer" *ngIf="this.startUpload">
        <button class="footer-button link-button" (click)="onLinkArtifacts()"
            [disabled]="!hasSelectedArtifacts()">LINK</button>
        <button class="footer-button cancel-button" (click)="closeModal()">CANCEL</button>
    </div>
</div>